import IdentityApiService from "@/core/services/apiServices/IdentityApiService";
import JwtService from "@/core/services/JwtService";
import router from "@/router";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "../enums/StoreEnums";

@Module
export default class LanguageModule extends VuexModule {
    languageCode = "tr";

    get language() {
        const langCode = JwtService.getLanguage()
        if (langCode) {
            return langCode
        }
        return this.languageCode
    }

    @Mutation
    [Mutations.SET_LANGUAGE](langCode) {
        this.languageCode = langCode;
    }

    @Action
    [Actions.CHANGE_LANGUAGE](langCode) {
        IdentityApiService.Membership.User.ChangeLanguage(langCode)
            .then(({ data }) => {
                this.context.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading")
                window.location.reload()
                JwtService.saveLanguage(langCode)
                this.context.commit(Mutations.SET_LANGUAGE, data.data.isoCode);
            })
            .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
    }
}